import React from "react";
import CIcon from "@coreui/icons-react";
import {
  cilBell,
  cilCalculator,
  cilChartPie,
  cilCursor,
  cilDrop,
  cilNotes,
  cilPencil,
  cilPuzzle,
  cilSpeedometer,
  cilStar,
  cilUser,
  cilPeople,
  cilGroup,
  cilLibrary,
  cilLocationPin,
  cilDollar,
  cilMoney,
  cilSchool,
  cilGraph,
  cilChartLine,
  cilChart,
  cilInstitution,
  cilCreditCard,
  cilApps,
  cilSettings,
  cilShare,cilLaptop,cilDescription,
} from "@coreui/icons";
import { CNavGroup, CNavItem, CNavTitle } from "@coreui/react";

const _nav = [
  {
    component: CNavTitle,
    name: "Zyple",
    visible: true,
  },
  {
    component: CNavGroup,
    name: "Administrator",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilApps} customClassName="nav-icon" />,
    
    items: [
      {
        component: CNavItem,
        name: "Company Setup",
        to: "/Administrator/CompanySetup",
        visible: true,
        //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
      },
      {
        component: CNavGroup,
        name: "System Initialization",
        to: "/",
        visible: true,
        icon: <CIcon icon={cilApps} customClassName="nav-icon" />,
        items: [
          {
            component: CNavItem,
            name: "General Settings",
            to: "/SystemInitialization/GeneralSettings",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "Branch Master",
            to: "/SystemInitialization/BranchMaster",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "PT Configuration",
            to: "/SystemInitialization/PTConfig",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "PF Configuration",
            to: "/SystemInitialization/PFConfig",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "ESI Configuration",
            to: "/SystemInitialization/ESIConfig",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "Approval Master",
            to: "/SystemInitialization/approvalmaster",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "City Master",
            to: "/SystemInitialization/CityMaster",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
          {
            component: CNavItem,
            name: "Unit Master",
            to: "/SystemInitialization/UnitMaster",
            visible: true,
            //icon: <CIcon icon={cilApps} customClassName="nav-icon" />
          },
        ],
      },
      {
        component: CNavGroup,
        name: "Master",
        to: "/",
        visible: true,
        icon: <CIcon icon={cilApps} customClassName="nav-icon" />,

        items: [
          {
            component: CNavGroup,
            name: "Users",
            to: "/users",
            visible: true,
            icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
            items: [
              {
                component: CNavItem,
                name: "User Group",
                to: "/users/usergroup",
                visible: true,
              },
              {
                component: CNavItem,
                name: "User Master",
                to: "/users/usermaster",
                visible: true,
              },
            ],
          },
          // {
          //   component: CNavGroup,
          //   name: "Utility Setup",
          //   to: "/utilitysetup",
          //   visible: true,
          //   icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
          //   items: [
          //     {
          //       component: CNavItem,
          //       name: "Unit Master",
          //       to: "/utilitysetup/unitmaster",
          //       visible: true,
          //     },
          //   ],
          // },
          {
            component: CNavGroup,
            name: "Employee Setup",
            to: "/",
            visible: true,
            icon: <CIcon icon={cilLibrary} customClassName="nav-icon" />,
            items: [
              {
                component: CNavItem,
                name: "Designation Master",
                to: "/EmployeeSetup/desigmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Department Master",
                to: "/EmployeeSetup/departmaster",
                visible: true,
                icon: (
                  <CIcon icon={cilInstitution} customClassName="nav-icon" />
                ),
              },
              {
                component: CNavItem,
                name: "Qualification Master",
                to: "/EmployeeSetup/qualimaster",
                visible: true,
                icon: <CIcon icon={cilSchool} customClassName="nav-icon" />,
              },
              // {
              //   component: CNavItem,
              //   name: "Branch Master",
              //   to: "/employee/locmaster",
              //   visible: true,
              //   icon: <CIcon icon={cilLocationPin} customClassName="nav-icon" />,
              // },
              {
                component: CNavItem,
                name: "Shift Master",
                to: "/EmployeeSetup/shiftmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Employee Category Master",
                to: "/EmployeeSetup/empcatemaster",
                visible: true,
                icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
              },
              {
                component: CNavItem,
                name: "Grade Master",
                to: "/EmployeeSetup/grademaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "ID Card Type Master",
                to: "/EmployeeSetup/idcardtypemaster",
                visible: true,
                icon: <CIcon icon={cilCreditCard} customClassName="nav-icon" />,
              },
              {
                component: CNavItem,
                name: "Currency  Master",
                to: "/EmployeeSetup/currencymaster",
                visible: true,
                icon: <CIcon icon={cilDollar} customClassName="nav-icon" />,
              },
              {
                component: CNavItem,
                name: "Known Language Master",
                to: "/EmployeeSetup/knownlangmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Contractor Master",
                to: "/EmployeeSetup/contractormaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Project Master",
                to: "/EmployeeSetup/projectmaster",
                visible: true,
                icon: <CIcon icon={cilGraph} customClassName="nav-icon" />,
              },
              {
                component: CNavItem,
                name: "Loan Type Master",
                to: "/EmployeeSetup/loantypemaster",
                visible: true,
              },
              // {
              //   component: CNavItem,
              //   name: "Skill Category Master",
              //   to: "/EmployeeSetup/skillcatemaster",
              //   visible: true,
              // },
              // {
              //   component: CNavItem,
              //   name: "Skill Set Master",
              //   to: "/EmployeeSetup/skillsetmaster",
              //   visible: true,
              // },
              // {
              //   component: CNavItem,
              //   name: "Hobbies Master",
              //   to: "/EmployeeSetup/hobbiesmaster",
              //   visible: true,
              // },
              // {
              //   component: CNavItem,
              //   name: "Social Media Master",
              //   to: "/EmployeeSetup/socialmediamaster",
              //   visible: true,
              // },
            ],
          },
          {
            component: CNavGroup,
            name: "Financial Setup",
            to: "/",
            visible: true,
            icon: <CIcon icon={cilChartLine} customClassName="nav-icon" />,
            items: [
              {
                component: CNavItem,
                name: "Financial Year Master",
                to: "/FinancialSetup/financialyearmaster",
                visible: true,
                icon: (
                  <CIcon icon={cilChart} size="sm" customClassName="nav-icon" />
                ),
              },
              {
                component: CNavItem,
                name: "Pay Element Master",
                to: "/FinancialSetup/payelementmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Salary Setup Master",
                to: "/FinancialSetup/salarysetupmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Bank Master",
                to: "/FinancialSetup/BankMaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Claim Group Master",
                to: "/FinancialSetup/claimGroupmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Claim Master",
                to: "/FinancialSetup/claimmaster",
                visible: true,
              },
            ],
          },
          {
            component: CNavGroup,
            name: "Leave Setup",
            to: "/leavesetup",
            visible: true,
            icon: <CIcon icon={cilPeople} customClassName="nav-icon" />,
            items: [
              {
                component: CNavItem,
                name: "Leave Type Master",
                to: "/LeaveSetup/leavesetupmaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Opening Leave Balance",
                to: "/LeaveSetup/openleavebal",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Leave Rule",
                to: "/LeaveSetup/LeaveRule",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Holiday Master",
                to: "/LeaveSetup/holidaymaster",
                visible: true,
              },
              {
                component: CNavItem,
                name: "Week Off Master",
                to: "/LeaveSetup/weekoff",
                visible: true,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    component: CNavGroup,
    name: "HR",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilLaptop} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Employee Master",
        to: "/HR/employeemaster",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Loan & Advance",
        to: "/HR/Loan",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Resignation",
        to: "/HR/Resignation",
        visible: true,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Employee Self Services",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilShare} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Time Attendance Entry",
        to: "/EmployeeSelfServices/timeattendance",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Leave Request",
        to: "/EmployeeSelfService/leavereq",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Compensatory Off Request",
        to: "/EmployeeSelfService/CompensatoryOff",
        visible: true,
      },
      {
        component: CNavItem,
        name: "OT Request",
        to: "/EmployeeSelfService/OTRequest",
        visible: true,
      },
      {
        component: CNavItem,
        name: "PaySlip",
        to: "/EmployeeSelfService/PaySlip",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Resignation Request",
        to: "/EmployeeSelfService/ResignationRequest",
        visible: true,
      },
      // {
      //   component: CNavItem,
      //   name: "Checkin / Checkout",
      //   to: "/EmployeeSelfService/Checkin",
      // },
      // {
      //   component: CNavItem,
      //   name: "Comb off Request",
      //   to: "/EmployeeSelfService/CompensatoryOffold",
      // },
      // {
      //   component: CNavItem,
      //   name: "Advance Reimbursment Request",
      //   to: "/EmployeeSelfService/Advance",
      // },
       {
        component: CNavItem,
        name: "Tour Approval Form",
        to: "/EmployeeSelfService/TourApproval",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Tour Report",
        to: "/EmployeeSelfService/TourReport",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Travel Expense",
        to: "/EmployeeSelfService/TravelExpense",
        visible: true,
      },
      {
        component: CNavItem,
        name: "Other Expense",
        to: "/EmployeeSelfService/OtherExpense",
        visible: true,
      },
     
    ],
  },
  {
    component: CNavGroup,
    name: "Payroll",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilShare} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "AttendanceUpload",
        to: "/payroll/AttendanceUpload",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "DailyWagesUpload",
        to: "/payroll/DailyWagesUpload",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Adocpayment",
        to: "/payroll/Adocpayment",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "AttendanceBettaUpload",
        to: "/payroll/AttendanceBettaUpload",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Payroll Process",
        to: "/payroll/Payrollprocess",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Payroll Process Lock",
        to: "/payroll/payrollprocesslock",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "PaySlip",
        to: "/payroll/PaySlip",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Pay Register",
        to: "/payroll/PayRegister",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Muster Roll",
        to: "/payroll/MusterRoll",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ],
  },
  {
    component: CNavGroup,
    name: "Reports",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Monthly Attendance",
        to: "/Reports/MonthlyAttendance",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Smart Report",
        to: "/Reports/SmartReport",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: "Paid or Verify",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Paid",
        to: "/Paid",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
      {
        component: CNavItem,
        name: "Verify",
        to: "/Verify",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: "Paid Tour Approval",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Paid",
        to: "/PaidTourApp",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ]
  },
  {
    component: CNavGroup,
    name: "Book Tour Approval",
    to: "/",
    visible: true,
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
    items: [
      {
        component: CNavItem,
        name: "Book",
        to: "/BookTourApp",
        visible: true,
        icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
      },
    ]
  },
  {
    component: CNavItem,
    name: "Approval List",
    to: "/ApprovalList",
    visible: true,
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
//   {
//     component: CNavGroup,
//     name: "ERP Integration",
//     to: "/",
//     visible: true,
//     icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
//     items: [
//   {
//     component: CNavGroup,
//     name: "SAP B1",
//     to: "/",
//     visible: true,
//     icon: <CIcon icon={cilLaptop} customClassName="nav-icon" />,
//     items: [
//       {
//         component: CNavGroup,
//         name: "Setup",
//         to: "/Setup",
//         visible: true,
//         icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//         items: [
//           {
//             component: CNavItem,
//             name: "Server Config",
//             to: "/SAPB1/Setup/ServerConfig",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//           {
//             component: CNavItem,
//             name: "GL Config",
//             to: "/SAPB1/Setup/GLConfig",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//         ]
//       },
//       {
//         component: CNavGroup,
//         name: "Pull",
//         to: "/Pull",
//         visible: true,
//         icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//         items: [
//           {
//             component: CNavItem,
//             name: "Project Master",
//             to: "/SAPB1/Pull/ProjectMaster",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//         ]
//       },
//       {
//         component: CNavGroup,
//         name: "Posting",
//         to: "/Posting",
//         visible: true,
//         icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//         items: [
//           {
//             component: CNavItem,
//             name: "Employee Cost Center",
//             to: "/SAPB1/Posting/EmployeeCostCenter",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//           {
//             component: CNavItem,
//             name: "Loan & Advance",
//             to: "/SAPB1/Posting/LoanAdvance",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//           {
//             component: CNavItem,
//             name: "Payroll",
//             to: "/SAPB1/Posting/Payroll",
//             visible: true,
//             //icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
//           },
//         ]
//       }
//     ]
//   }
// ]
//   }
  // {
  //   component: CNavGroup,
  //   name: "Report",
  //   to: "/",
  //   visible: true,
  //   icon: <CIcon icon={cilApps} customClassName="nav-icon" />,
  // },
];

export default _nav;
